import { FilesComponent } from "./Files";

export function TableItemComponent() {
  return <></>;
}

TableItemComponent.Files = FilesComponent;
